import { APP_PAGES_CONFIG, APP_PAGES_NAMES } from 'constants/routes';

import { addPathNameSlash } from 'shared/lib/addPathNameSlash';

import type { TPersistedConfigByRoute, TPersistedStorePaths } from './types';

// Общие пути, которые сохраняем (первые два шага формы)
export const COMMON_INCLUDE_FIELDS: TPersistedStorePaths = [
  'creditForm.creditPurposeForm.data',
  'creditForm.contactsForm.data',
];

// Общие исключения не сохраняем:
// мобильный телефон
// сумму, срок и цель кредита (т.к. эти данные могут быть указаны в URL в query-параметрах)
export const COMMON_EXCLUDE_FIELDS: TPersistedStorePaths = [
  'creditForm.contactsForm.data.mobilePhone',
  'creditForm.creditPurposeForm.data.amount',
  'creditForm.creditPurposeForm.data.period',
  'creditForm.creditPurposeForm.data.purpose',
];

// Доп поля анкеты с лендингов витрин
export const LANDING_PAGE_PASSPORT_FIELDS: TPersistedStorePaths = [
  'creditForm.passportForm.data.fullName',
  'creditForm.passportForm.data.gender',
  'creditForm.passportForm.data.region',
  'creditForm.passportForm.data.regionLocationRoute',
];

// Лендинги витрин, где действует одна логика сохранения
export const LANDING_PAGE_NAMES = [
  APP_PAGES_NAMES.IPHONEE,
  APP_PAGES_NAMES.NALICHNYMI,
  APP_PAGES_NAMES.BEZ_POSESHHENIJA_BANKA,
  APP_PAGES_NAMES.OBRAZOVANIE,
  APP_PAGES_NAMES.MARKETPLACE_SEO_LANDING,
] as const;

export const BASE_PERSISTED_ROUTES: TPersistedConfigByRoute = {
  [addPathNameSlash(APP_PAGES_CONFIG.newFormWL.web)]: ['whiteLabelUserData'],
};

// Конфиг маршрутов для авторизованного пользователя
export const AUTH_PERSISTED_ROUTES: TPersistedConfigByRoute = {
  [addPathNameSlash(APP_PAGES_CONFIG.newForm.web)]: {
    include: [...COMMON_INCLUDE_FIELDS, ...LANDING_PAGE_PASSPORT_FIELDS],
    exclude: COMMON_EXCLUDE_FIELDS,
  },
  [addPathNameSlash(APP_PAGES_CONFIG.newFormWL.web)]: {
    include: [...COMMON_INCLUDE_FIELDS, 'whiteLabelUserData'],
    exclude: COMMON_EXCLUDE_FIELDS,
  },
  ...LANDING_PAGE_NAMES.reduce<TPersistedConfigByRoute>((acc, pageName) => {
    acc[addPathNameSlash(APP_PAGES_CONFIG[pageName].web)] = {
      include: [...COMMON_INCLUDE_FIELDS, ...LANDING_PAGE_PASSPORT_FIELDS],
      exclude: COMMON_EXCLUDE_FIELDS,
    };
    return acc;
  }, {}),
};
